module.exports = __webpack_public_path__ + "static/media/cafet.e82682c0.png";